// extracted by mini-css-extract-plugin
var _1 = "ra-avatar-section-left";
var _2 = "ra-avatar-section";
var _3 = "#000000";
var _4 = "ra-avatar-section-image";
var _5 = "ra-avatar-section-letter";
var _6 = "ra-avatar-section-size-large";
var _7 = "ra-avatar-section-size-medium";
var _8 = "ra-avatar-section-size-small";
var _9 = "ra-avatar-section-text";
var _a = "ra-avatar-section-theme-black";
export { _1 as "avatarAlignLeftCls", _2 as "avatarCls", _3 as "avatarColor", _4 as "avatarImageCls", _5 as "avatarLetterCls", _6 as "avatarSizeLargeCls", _7 as "avatarSizeMediumCls", _8 as "avatarSizeSmallCls", _9 as "avatarTextCls", _a as "avatarThemeBlackCls" }
